import React from 'react'
import Modal from 'react-modal'
import { useMutation } from '@apollo/client'
import addCollaborator from '../mutations/add-colleague-to-project'
import removeCollaborator from '../mutations/remove-colleague-from-project'

const className = {
  base: 'modal share-project',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

function ShareProject(props) {
  const [email, setEmail] = React.useState(null)
  const [addCollaboratorMutation] = useMutation(addCollaborator)
  const [removeCollaboratorMutation] = useMutation(removeCollaborator)

  const handleChange = (e) => {
    setEmail(e.target.value)
  }

  const handleSubmit = (e) => {
    e.stopPropagation()

    const {
      afterShare,
      project: { id },
    } = props

    addCollaboratorMutation({
      variables: { id, email },
    }).then(afterShare)
  }

  const handleRemoveCollab = (e) => {
    e.stopPropagation()

    const {
      afterShare,
      onCancel,
      project: { id },
    } = props

    removeCollaboratorMutation({
      variables: { id },
    }).then(() => {
      afterShare()
      onCancel()
    })
  }
  const { isOpen, onCancel, project } = props
  const collaborator = project && project.collaborator

  if (collaborator) {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onCancel}
        contentLabel="Share Project Modal"
        className={className}
        overlayClassName={overlayClassName}
      >
        <div>
          <a className="close" onClick={onCancel}>
            Cancel
          </a>
        </div>
        <h2>Invite a Colleague</h2>
        <p>
          You are allowed a maxiumum of 1 colleague per reflEQ. If you'd like to
          share with a different colleague, remove the one below.
        </p>
        <div className="current-collab">
          <div>
            <strong>{collaborator.name}</strong>
          </div>
          <div>{collaborator.email}</div>
          <div onClick={handleRemoveCollab}>
            <a>Remove</a>
          </div>
        </div>
      </Modal>
    )
  } else {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onCancel}
        contentLabel="Share Project Modal"
        className={className}
        overlayClassName={overlayClassName}
      >
        <div>
          <a className="close" onClick={onCancel}>
            Cancel
          </a>
        </div>
        <h2>Invite a Colleague</h2>
        <p>
          Your colleague will receive joint access to this project. You can
          collaborate to assign prompts and view student reflections.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="field floating section-name">
            <input type="text" value={email} onChange={handleChange} required />
            <label>Colleague's Email Address</label>
            <div className="highlight" />
          </div>
          <button onClick={handleSubmit}>Add to project</button>
        </form>
      </Modal>
    )
  }
}

export default ShareProject
